// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_problem_body1 = /** @type {(inputs: {}) => string} */ () => {
	return `Your feet evolved for soft, uneven ground — forest floors, grasslands, sand. Every muscle and joint was designed for surfaces that give.`
};

const el_tech_problem_body1 = /** @type {(inputs: {}) => string} */ () => {
	return `Τα πόδια σας εξελίχθηκαν για μαλακό, ανώμαλο έδαφος — δασικά εδάφη, λιβάδια, άμμο. Κάθε μυς και άρθρωση σχεδιάστηκε για επιφάνειες που υποχωρούν.`
};

const ru_tech_problem_body1 = /** @type {(inputs: {}) => string} */ () => {
	return `Ваши стопы созданы для мягкой, неровной поверхности — лесной подстилки, лугов, песка. Каждая мышца и сустав рассчитаны на поверхности, которые пружинят.`
};

const he_tech_problem_body1 = /** @type {(inputs: {}) => string} */ () => {
	return `כפות הרגליים שלכם התפתחו למשטחים רכים ולא אחידים — קרקעית יער, מרעה, חול. כל שריר ומפרק תוכנן למשטחים שנענים.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_problem_body1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_problem_body1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_problem_body1", locale)
	if (locale === "en") return en_tech_problem_body1(inputs)
	if (locale === "el") return el_tech_problem_body1(inputs)
	if (locale === "ru") return ru_tech_problem_body1(inputs)
	if (locale === "he") return he_tech_problem_body1(inputs)
	return "tech_problem_body1"
};